/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProgramRequest } from '../models/ProgramRequest';
import type { ProgramResponse } from '../models/ProgramResponse';
import type { Programs } from '../models/Programs';
import type { ProgramWithCriteriaResponse } from '../models/ProgramWithCriteriaResponse';
import type { TaskName } from '../models/TaskName';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProgramRoutesRepository {
  /**
   * Get All Programs
   * Lists all programs.
   * @returns ProgramResponse Successful Response
   * @throws ApiError
   */
  public static programRoutesGetAllPrograms({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<Array<ProgramResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/programs',
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Program
   * Creates a new program.
   * @returns ProgramResponse Successful Response
   * @throws ApiError
   */
  public static programRoutesCreateProgram({
    requestBody,
    authorization,
  }: {
    requestBody: ProgramRequest,
    authorization?: string,
  }): CancelablePromise<ProgramResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/programs',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Program
   * Get program by id.
   * @returns ProgramWithCriteriaResponse Successful Response
   * @throws ApiError
   */
  public static programRoutesGetProgram({
    programId,
    authorization,
  }: {
    programId: string,
    authorization?: string,
  }): CancelablePromise<ProgramWithCriteriaResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/programs/{program_id}',
      path: {
        'program_id': programId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Program
   * Updates a program by id.
   * @returns ProgramWithCriteriaResponse Successful Response
   * @throws ApiError
   */
  public static programRoutesUpdateProgram({
    programId,
    requestBody,
    authorization,
  }: {
    programId: string,
    requestBody: ProgramRequest,
    authorization?: string,
  }): CancelablePromise<ProgramWithCriteriaResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/programs/{program_id}',
      path: {
        'program_id': programId,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get All Contractor Programs By Job
   * Lists all programs for a contractor.
   * @returns ProgramResponse Successful Response
   * @throws ApiError
   */
  public static programRoutesGetAllContractorProgramsByJob({
    id,
    authorization,
  }: {
    id: string,
    authorization?: string,
  }): CancelablePromise<Array<ProgramResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/programs/job/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get All Tasks
   * Get all tasks for a program.
   * @returns TaskName Successful Response
   * @throws ApiError
   */
  public static programRoutesGetAllTasks({
    program,
    authorization,
  }: {
    program: Programs,
    authorization?: string,
  }): CancelablePromise<Array<TaskName>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/programs/{program}/tasks',
      path: {
        'program': program,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
